// extracted by css-extract-rspack-plugin
export default {"container":"container-zy5hTi"};